// Dependencies.
import Vue from "vue";
import App from "./App";
import router from "./config/router/index";

// Plugins.
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
Vue.use(PaperDashboard);

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
